import { gql } from "@apollo/client";


export const CONTACT_US = gql`
mutation InsertContactUs($input: contactUsInput!) {
  insertContactUs(input: $input)
}
`